import { ActionTree } from 'vuex';
import { RootState } from '@/store/types';
import { ICardListState } from '@/store/interfaces';

export const actions: ActionTree<ICardListState, RootState> = {
  setCardList({ commit }, cardList) {
    commit('SET_CARD_LIST', cardList);
  },
};
